import { render, staticRenderFns } from "./Refund_wait_for_process.vue?vue&type=template&id=fadd26bc&scoped=true&"
import script from "./Refund_wait_for_process.vue?vue&type=script&lang=js&"
export * from "./Refund_wait_for_process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadd26bc",
  null
  
)

export default component.exports